// RITA-1525 — Druckansicht außerhalb der App-Oberfläche.
//
// Beim Drucken (und bei Playwrights page.pdf, das Druckmedien verwendet) blendet das Stylesheet
// #root aus und zeigt nur dieses Portal. So bleibt die Seitenansicht frei von Navigation und
// Werkzeugleiste, ohne deren Aufbau zu kennen. Die Druckregeln gelten nur, solange das Portal
// eingehängt ist: Es setzt die Body-Klasse DRUCK_AKTIV und entfernt sie beim Aushängen, damit
// andere PRM-Seiten unverändert drucken.
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: React.ReactNode;
}

export const DRUCK_AKTIV = 'vertrag-druck-aktiv';

function VertragDruckportal({ children }: Props) {
  const [ziel] = useState(() => document.createElement('div'));

  useEffect(() => {
    ziel.className = 'vertrag-druckansicht';
    ziel.setAttribute('data-testid', 'vertrag-druckansicht');
    document.body.appendChild(ziel);
    document.body.classList.add(DRUCK_AKTIV);
    return () => {
      document.body.classList.remove(DRUCK_AKTIV);
      document.body.removeChild(ziel);
    };
  }, [ziel]);

  return createPortal(children, ziel);
}

export default VertragDruckportal;
